import { IS_BAD, IS_HIDDEN } from '../Utility/State'

class CartCountdown {
  private static readonly WARNING_THRESHOLD_MS = 60 * 1000

  private intervalId: null | number = null
  private timeoutId: null | number = null

  constructor(
    private readonly notice: HTMLElement,
    private readonly valueElement: HTMLElement,
    private readonly onExpire?: () => void,
  ) {}

  public start(expiresAt: number): void {
    this.stop()

    if (expiresAt <= Date.now()) {
      this.notice.classList.add(IS_HIDDEN)
      this.onExpire?.()
      return
    }

    this.notice.classList.remove(IS_HIDDEN)
    this.tick(expiresAt)
    this.intervalId = window.setInterval((): void => this.tick(expiresAt), 1000)
    this.timeoutId = window.setTimeout((): void => {
      this.stop()
      this.notice.classList.add(IS_HIDDEN)
      this.onExpire?.()
    }, expiresAt - Date.now())
  }

  public stop(): void {
    if (this.intervalId !== null) {
      window.clearInterval(this.intervalId)
      this.intervalId = null
    }
    if (this.timeoutId !== null) {
      window.clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
  }

  private formatRemaining(ms: number): string {
    const total = Math.max(0, Math.floor(ms / 1000))
    const minutes = Math.floor(total / 60)
    const seconds = total % 60
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
  }

  private tick(expiresAt: number): void {
    const remaining = expiresAt - Date.now()
    this.valueElement.textContent = this.formatRemaining(remaining)
    this.notice.classList.toggle(IS_BAD, remaining > 0 && remaining < CartCountdown.WARNING_THRESHOLD_MS)
  }
}

export default CartCountdown
